import clsx from 'clsx'
import env from 'config/env'
import Typo from 'constants/typography'

export const getNearestBtsData = (value) => (value ? value.split(', ') : null)

export const renderTrainStation = (className, station) => (
  <span key={station} className={clsx(className, Typo.body2)}>
    {station}
  </span>
)

export const renderStoreAndMapImages = (address, type) => {
  let imageIdString

  switch (type) {
    case 'zoomedMapMain':
      imageIdString =
        (address &&
          address.images &&
          address.images.floormap &&
          address.images.floormap.main) ||
        null
      break
    case 'mainImage':
    default:
      imageIdString =
        (address &&
          address.images &&
          address.images.store &&
          address.images.store.primary &&
          address.images.store.primary.landscape) ||
        null
      break
  }

  return `${env.IMG_HOST}${imageIdString}`
}
